var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.355 16.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6f2380;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TEXT_GENERATOR",
    "data-name": "TEXT GENERATOR"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.23,2.249H1.125A1.125,1.125,0,1,1,1.125,0H22.23a1.125,1.125,0,1,1,0,2.249Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.23,9.516H1.125a1.125,1.125,0,1,1,0-2.249H22.23a1.125,1.125,0,1,1,0,2.249Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.23,16.783H1.125a1.125,1.125,0,0,1,0-2.25H22.23a1.125,1.125,0,1,1,0,2.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger2);
export default __webpack_public_path__ + "static/media/hamburger2.1e849f5742584d8f308a02887ec6c74a.svg";
export { ForwardRef as ReactComponent };